import { DashboardWidgetType } from 'features/dashboard/types'
import { InsightData } from 'schemas/action/InsightDataSchema'
import { WidgetSettingComposingStrategy } from './widgetSettingComposingStrategy'

const canBeDrilledDown = (widgetSetting: DashboardWidgetType) =>
  widgetSetting.includedDomains === undefined ||
  widgetSetting.includedDomains === null ||
  widgetSetting.includedDomains.length === 0

const isOverMaxInput = (applicationSettings: any) => (insights: InsightData[]) =>
  insights.length > applicationSettings?.analysisMaxDomains

const composeDrillDownWidgetSetting = (
  widgetSetting: DashboardWidgetType,
  insights: InsightData[]
) => ({
  ...widgetSetting,
  includedDomains: insights.map((insight) => insight.name)
})

const generateIncludedDomainsNameStrategy = (
  applicationSettings: any
): WidgetSettingComposingStrategy => ({
  canBeDrilledDown,
  isOverMaxInput: isOverMaxInput(applicationSettings),
  composeDrillDownWidgetSetting
})

export default generateIncludedDomainsNameStrategy
